import {
  Grid,
  IconButton as MuiIconButton,
  TableContainer as MuiTableContainer,
  TableCell as MuiTableCell,
} from "@mui/material";
import { styled } from "@mui/material/styles";

export const Container = styled(Grid)({
  width: "100%",
  marginBottom: 20,
});

export const TableContainer = styled(MuiTableContainer)({
  maxHeight: 250,
});

export const IconButton = styled(MuiIconButton)({
  fontSize: "1.2rem",
});

export const TableCell = styled(MuiTableCell)({
  background: "white",
});
